document.addEventListener('DOMContentLoaded', () => {

  const sizeSelect = document.getElementById('size-select');
  const productImage = document.getElementById('product-image');
  const productView = document.getElementById('product-view');

  if (!sizeSelect || !productImage) return;

  sizeSelect.addEventListener('change', () => {
    const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
    if (!selectedOption) return;

    const variantImage = selectedOption.getAttribute('data-image');

    if (variantImage) {
      // Update the main image
      productImage.src = variantImage;
      productImage.srcset = '';

      // Keep prev/next navigation in sync
      if (productView) {
        const images = (productView.dataset.images || '').split(',');
        const newIndex = images.indexOf(variantImage);
        if (newIndex !== -1) {
          productView.dataset.currentIndex = newIndex.toString();
        }
      }
    }
  });

});